import { useEffect } from 'react';
import { atom, useRecoilState } from 'recoil';

const onlineState = atom<boolean>({
  key: 'online',
  default: true,
});

/**
 * Checks if the client is currently online.
 * Utilizes navigator.onLine and online/offline events.
 * @returns true, when the client is online.
 */
export const useOnline = () => {
  const [isOnline, setIsOnline] = useRecoilState(onlineState);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };
    setIsOnline(navigator.onLine);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setIsOnline]);

  return isOnline;
};
